import React, { Fragment, useState, useEffect } from "react";
import "./styles.css";
import {
  verifyOTP,
  verifyMobile,
  clearOTPState,
  resetPasswordInitiateSuccess,
  clearResetPassword,
  clearVerifyMobile,
} from "common/features/auth/AuthActions";
import { ReactComponent as TickIcon } from "common/assets/svg/tickIconOffer.svg";
import { ReactComponent as Cancel } from "common/assets/svg/cancel.svg";

import { useSpring, useTransition, animated } from "react-spring";
import { useHistory, useParams, useLocation } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "common/rootReducer";
import { setCartAuthPending } from "common/features/cart/cartActions";
import SignIn from "pages/authPages/signIn";
import InnerOtp from "pages/authPages/innerOtp";
import PasswordVerifyOTP from "../passwordOTP";
import { ReactComponent as BackIcon } from "common/assets/svg/leftArrow.svg";

function LoginRequest(props: any) {
  const dispatch = useDispatch();
  const location = useLocation<any>();

  const { isOpen, visible,onSuccessSignUp,type } = props;
  const history = useHistory();
  const [loginRequestPopup, setloginRequestPopup,] = useState(false);

  const [user, setUser] = useState({ email: "", password: "" });
  const [signUp, setSignUp] = useState(false);
  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   setUser({ ...user, [name]: value })
  // }

  const handleClick = () => {
    // setOpen(!open)
    setloginRequestPopup(true);
  };
  const opacityProps = useSpring({
    from: { opacity: 0 },
    to: { opacity: isOpen ? 1 : 0 },
  });

  const transitions = useTransition(isOpen, null, {
    from: { transform: "translate3d(0,-15px,0)" },
    enter: { transform: "translate3d(0,0px,0)" },
    leave: { transform: "translate3d(0,-15px,0)" },
    unique: true,
  });

  const handleSubmit = () => {
    console.log(user, "user");
  };

  const handleSignUp = () => {
    setSignUp(!signUp);
  };

  return (
    <Fragment>
      {isOpen ? (
        <Fragment>
          <div id="modal-background"></div>
          <animated.div className="CPWrapper" style={opacityProps}>
            {transitions.map(({ item, key, props }) =>
              item ? (
                <animated.div
                  className="CPContainer"
                  key={key}
                  //  style={props}
                  style={{ backgroundColor: "#EDEDED", width: 430 }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderWidth: 2,
                      borderColor: "pink",
                    }}
                  >
                    {/* <span id="return-back">
                      <BackIcon
                        style={{ marginTop: 10, marginLeft: 25 }}
                        onClick={() => {
                          dispatch(clearResetPassword());
                          history.goBack();
                        }}
                        className="darkBackIcon"
                      />
                    </span> */}
                    <span
                      className="title-text"
                      style={{
                        alignSelf: "center",
                        borderBottomWidth: 2,
                        borderBottomColor: "red",
                        fontSize: 25,
                        marginLeft: '0'
                      }}
                    >
                      {/* {title} */}
                      OTP Verification
                    </span>
                    <Cancel onClick={() => visible(true)} className="cancel" />
                  </div>

                  <div>
                    <InnerOtp type={type ? type :"signup"} title="OTP" onClose={()=>{visible(true)}} onSuccessSignUp={()=>{visible(true);onSuccessSignUp(true)}}/>
                  </div>
                </animated.div>
              ) : null
            )}
          </animated.div>
        </Fragment>
      ) : null}
    </Fragment>
  );
}

export default LoginRequest;
